import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import { API_ROUTES, getCountryName } from '../../../../../utils/constants';
import InfiniteGrid from '../infiniteGrid';
import {
  getFiltersFromQueryParams,
  getMappedJurorFilterDates,
} from '../../../../../helpers/filters';
import { useLocale } from '../../../../../context/locale.context';

import { getAPIRoot } from '../../../../../helpers/fetch';
import placeholderImage from '../../../../../images/placeholder-image.png';

const DEFAULT_FILTERS = {
  awards: [],
  range: 4,
  countries: [],
  find: '',
  sort: 'desc',
};

const QUERY_PARAM_MAPPING = {
  awardId: 'awards',
  countryId: 'countries',
  yearId: 'range',
};

const InfiniteJurors = ({ setTotal, filtersAsQueryString, limit }) => {
  const [jurors, setJurors] = useState([]);
  const [loading, setLoading] = useState(true);
  const { locale } = useLocale();

  const filters = getFiltersFromQueryParams(
    DEFAULT_FILTERS,
    filtersAsQueryString,
    QUERY_PARAM_MAPPING
  );

  const fetchJurors = async () => {
    let apiRoot = await getAPIRoot();

    await fetch(
      `${apiRoot}${API_ROUTES.UNPAGINATED_JURORS}/${limit}/${filters.sort}`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        const data = res.items
          .sort((a, b) => a.surname.localeCompare(b.surname))
          .map((item) => {
            return {
              image: {
                url: item.pictureProfile || placeholderImage,
                description: `${item.firstName} ${item.surname}`,
                isContainImage: !res.pictureProfile,
              },
              title: `${item.firstName} ${item.surname}`,
              subline: getCountryName(locale, item.country) || '',
              link: { linkToPage: item.slug },
            };
          });
        setLoading(false);
        setJurors(data);
        setTotal(res.count);
      });
  };

  useEffect(() => {
    fetchJurors();
  }, []);

  return <InfiniteGrid items={jurors} loading={loading} />;
};

InfiniteJurors.propTypes = {
  setTotal: pt.func,
  filtersAsQueryString: pt.string,
  limit: pt.number,
};

InfiniteJurors.defaultProps = {
  setTotal: () => {},
  filtersAsQueryString: '',
  limit: 150,
};

export default InfiniteJurors;
